module.exports = __webpack_public_path__ + "static/media/IC_assessment.f87c7abe.svg";